import { ABP, ConfigStateService, eLayoutType, PermissionService, RoutesService, TreeNode } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eThemeSharedRouteNames } from '@abp/ng.theme.shared';
import { FeatureConstants } from 'src/core/constants/feature-constant';
import { PermissionConstants } from 'src/core/constants/permission-constant';
import { RouteNames } from 'src/core/constants/route-names.constant';
import { takeUntil, timer } from 'rxjs';
import { SettingTabsService } from '@abp/ng.setting-management/config';

export const APP_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService, ConfigStateService, SettingTabsService],
    multi: true,
  },
];

function configureRoutes(
  routesService: RoutesService,
  config: ConfigStateService,
  settingTabsService: SettingTabsService,
) {
  return () => {
    if (window.location.pathname.startsWith('/external')) {
      return;
    }

    var routes = [
      {
        name: 'UserGroup::Menu:InteractionManagement',
        iconClass: 'far fa-user-friends',
        order: 0,
        path: '/administration/interaction-management',
        parentName: eThemeSharedRouteNames.Administration,
        forSettings: ['InteractionManagement.Enabled'],
        requiredPolicy: PermissionConstants.InteractionManagement,
      },
      {
        name: 'Licensing::Menu:LicenseManagement',
        iconClass: 'far fa-key',
        order: 1,
        path: '/administration/license-management',
        parentName: eThemeSharedRouteNames.Administration,
        requiredPolicy: 'Administration.LicenseManagement',
      },
      {
        name: 'Licensing::Menu:UserLicenses',
        iconClass: 'far fa-key',
        order: 2,
        path: '/administration/user-licenses',
        parentName: 'Licensing::Menu:LicenseManagement',
      },
      {
        name: 'UserGroup::Menu:UserGroups',
        iconClass: 'far fa-users-class',
        order: 3,
        path: '/identity/user-groups',
        parentName: RouteNames.IdentityManagement,
        forSettings: ['InteractionManagement.Enabled'],
        requiredPolicy: PermissionConstants.InteractionManagement,
      },
      {
        name: '::Integration',
        iconClass: 'far fa-project-diagram',
        order: 4,
        path: '/administration/integration',
        parentName: eThemeSharedRouteNames.Administration,
        requiredPolicy: 'DefinitionManagement.Integration',
      },
      {
        name: 'CoachingAndTraining::EmailAlertLogs',
        order: 5,
        iconClass: 'far fa-list',
        path: '/administration/email-alert-log',
        parentName: eThemeSharedRouteNames.Administration,
        requiredPolicy: 'CoachingAndTraining.EmailAlert',
        forSettings: ['Abp.Identity.SignIn.RequireConfirmedEmail'],
      },
      {
        name: 'Settings::InitialSetup.InitialSettings',
        path: '/initial-setup',
        layout: eLayoutType.empty,
        invisible: true,
      },
    ];
    routesService.add(routes);
    routesService.patch(RouteNames.LanguagesPage, { invisible: true });

    const timer$ = timer(10000);
    routesService.visible$.pipe(takeUntil(timer$)).subscribe(x => {
      var administrationMenu = x.filter(r => r.name.includes('Administration'))[0];
      if (administrationMenu) {
        if (!checkAdministrationMenuVisibility(administrationMenu, settingTabsService)) {
          if (
            administrationMenu.invisible == null ||
            administrationMenu.invisible == undefined ||
            administrationMenu.invisible == false
          ) {
            routesService.patch(eThemeSharedRouteNames.Administration, { invisible: true });
          }
        }
      }
    });
  };
}

function checkAdministrationMenuVisibility(
  route: TreeNode<ABP.Route>,
  settingTabsService?: SettingTabsService,
): boolean {
  const hasChild = !!settingTabsService?.flat?.length;
  if (hasChild) {
    return true;
  }

  if (!route || !route.children || route.children.length <= 0) {
    return false;
  }

  if (route.children.length > 0) {
    return true;
  }

  return false;
}
